import "../../../assets/scss/account-style.scss";
import { useEffect, useState } from "react";
import { Descriptions, DescriptionsProps, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import Chart from "react-google-charts";

import { useAppSelector } from "../../store/hooks";
import { getRentalHistory } from "../../server/User";
import { EditUserInfo } from "../../components/EditUserInfo";
import { SSHPublicKeyTable } from "../sshPublicKeyTable";

export const Account = () => {
  const { t } = useTranslation();
  const userState = useAppSelector((state: any) => state.user);
  const [imgSrc, setImgSrc] = useState<string>(userState.picture);
  const [gpuDataType, setGpuDataType] = useState<any[]>([]);
  const [templateDataType, setTemplateDataType] = useState<any[]>([]);
  const [editInfo, setEditInfo] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: t("Name"),
      children: (
        <>
          {userState.given_name} {userState.family_name}
        </>
      ),
      span: 3,
    },
    {
      key: "2",
      label: t("E-Mail"),
      children: <>{userState.email}</>,
      span: 3,
    },
  ];

  const GPUData = [["GPU Type", "Used Times"], ...gpuDataType];
  const TemplateData = [["Template Name", "Used Times"], ...templateDataType];

  const countOccurrences = (itemToFind: string, dataArray: any[]) => {
    const countMap: any = {};

    // Count occurrences
    dataArray.forEach((item: any) => {
      const itemName = item[itemToFind];
      const baseName = itemName.replace(/-\d+$/, "");
      if (baseName) {
        countMap[baseName] = (countMap[baseName] || 0) + 1;
      }
    });

    // Convert to an array of objects
    return Object.entries(countMap);
  };

  const getRentalHistoryData = async () => {
    setLoading(true);
    try {
      const response = await getRentalHistory(1, 20);
      let data = response.data.rental_history;
      let productName = countOccurrences("product_name", data);
      let templateData = countOccurrences("template_name", data);
      setGpuDataType(productName);
      setTemplateDataType(templateData);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRentalHistoryData();
  }, []);

  return (
    <>
      <div className="wrapper">
        <div className="upper-info">
          <div className="upper-info-title-wrapper">
            <h4>{t("User Info")}</h4>
            <button
              className={editInfo ? "secondary-btn" : "primary-btn"}
              onClick={() => {
                setEditInfo(!editInfo);
              }}
            >
              {editInfo ? <>{t("cancel")}</> : <>{t("Edit User")}</>}
            </button>
          </div>
          <div className={editInfo ? "user-details forms" : "user-details"}>
            {editInfo ? (
              <EditUserInfo />
            ) : (
              <>
                <img
                  style={{ borderRadius: "12%", width: "96px" }}
                  src={imgSrc}
                  onError={() => setImgSrc("/images/user/user_icon.png")}
                  alt="user image"
                />
                <Descriptions items={items} />
              </>
            )}
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div className="upper-info-title-wrapper">
          <h4>{t("Instance Public Keys")}</h4>
        </div>
        <div className="keys-wrapper">
          <SSHPublicKeyTable />
        </div>
      </div>
    </>
  );
};
